import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["mainDashboard", "list", "view", "3333", "4444", "5555", "6666", "7777", "8888", "9999"]

  connect() {
    this.controllerName = `operations--products--clinics--managements--regimes--dashboard`
  }

  doRegimesDashboard() {
    var html = `<div class="row" data-${this.controllerName}-target="mainDashboard">
                  <div class="col-7 pr-1" data-${this.controllerName}-target="list" data-controller="operations--products--clinics--financials--regimes--index"></div>
                  <div class="col-5 pl-1" data-${this.controllerName}-target="view" data-controller="operations--products--clinics--financials--regimes--save operations--products--clinics--financials--regimes--show"></div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier(`operations--products--clinics--managements--show--main`).contentTarget.innerHTML = html)
    }).then(() => {
      controller.getControllerByIdentifier(`operations--products--clinics--managements--show--submenu`).dashboardToggleBtn(`TRIBUTÁRIO`)
      controller.getControllerByIdentifier(`operations--products--clinics--financials--regimes--index`).controllerDash = this
      controller.getControllerByIdentifier(`operations--products--clinics--financials--regimes--show`).controllerDash = this
      controller.getControllerByIdentifier(`operations--products--clinics--financials--regimes--save`).controllerDash = this

      controller.getControllerByIdentifier(`operations--products--clinics--financials--regimes--index`).permission = `medclinic_management_regimes`
      controller.getControllerByIdentifier(`operations--products--clinics--financials--regimes--show`).permission = `medclinic_management_regimes`
      controller.getControllerByIdentifier(`operations--products--clinics--financials--regimes--save`).permission = `medclinic_management_regimes`
      
      controller.getControllerByIdentifier(`operations--products--clinics--financials--regimes--index`).doIndexListHtml()
      controller.getControllerByIdentifier(`operations--products--clinics--financials--regimes--show`).doViewHtml()
    })
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
